/*
 * Digitization Dashboard Wrapper for PCMP
 * Imports the Digitization Dashboard from schrockenAdmin settings
 * and wraps it for use within PCMP module
 */

import Digitization from '../../../../schrockenAdmin/settings/digitization';

const DigitizationDashboard = (props) => {
  return <Digitization {...props} />;
};

export default DigitizationDashboard;
